import React, { useEffect, useState } from 'react'
import { AiOutlineDelete } from "react-icons/ai";
import { Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom'
import { cloneDeep, debounce, trim, findIndex } from 'lodash';
import { Box } from '@mui/material';

import Drawer from "../../../../components/uiComponent/drawer/index"
import SearchInput from '../../../../components/uiComponent/inputs/searchinput/index';
import Button from "../../../../components/uiComponent/button/index";
import AgGrid from "../../../../components/ag-grid-table/index";
import Input from "../../../../components/uiComponent/inputs/input/index"
import Modal from "../../../../components/uiComponent/modal/index";
import ReactSelect from '../../../../components/uiComponent/select';

import LeftArrow from "../../../../assets/icons/left-arrow.svg"
import ProductImg from "../../../../assets/images/newImages/nestle.svg";

import { DrawerWrapperUI } from '../style';
import { GetProductsList, AddPoItems } from '../../../../slices/po';
import { CreateNewVendorItem } from '../../../../slices/vendor-items';
import { getIdentifierValidationError } from '../../../../utils/identifierValidation';

const defaultColDefNew = {
  resizable: true,
  sortable: false,
  filter: false,
  suppressRowClickSelection: true,
};

const columnDefs = [
  {
    headerName: "",
    width: 70,
    field: "action",
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressRowClickSelection: true,
  },
  {
    headerName: "Item Name",
    flex: 1,
    filter: true,
    cellRenderer: ({ data }) => {
      const { vendor_item_name } = data || {};

      return (
        <div className='card-wrapper'>
          {/* <img src={image_url || ProductImg} alt="ProductImg" title="ProductImg" /> */}
          <span className='two-line-ellipsis'>
            {vendor_item_name || '---'}
          </span>
        </div>
      )
    }
  },
  {
    headerName: "Identifier",
    flex: 1,
    filter: true,
    cellRenderer: ({ data }) => {
      const { identifier_type, identifier_value } = data || {};

      return (
        <div className='title-wrapper'>
          <span>{identifier_type?.toUpperCase() || ''}</span>
          <span className='upc-code'>{identifier_value || ''}</span>
        </div>
      )
    }
  },
  {
    headerName: "Case Qty",
    field: "case_quantity",
    sortable: true,
    flex: 1,
    filter: true,
    comparator: () => 0,
    cellRenderer: ({ value = 0 }) => `${Number(value).toFixed(2)}`
  },
  {
    headerName: "MOQ",
    field: "minimum_order_quantity",
    sortable: true,
    flex: 1,
    filter: true,
    comparator: () => 0,
    cellRenderer: ({ value }) => value || 0
  },
];

let gridApi;

const AddProductByUpload = ({ setShowDrawer, showDrawer, setAddProduct, refreshPage }) => {
  const dispatch = useDispatch();
  const { poId } = useParams();

  const [showAddDetails, setShowAddDetails] = useState(false);
  const [AddVendorItem, setAddVendorItem] = useState(false);
  const [mappedProducts, setMappedProducts] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [filters, setFilters] = useState({ search: '' });
  const [createVendorItem, setCreateVendorItem] = useState({});

  const closeDrawer = () => setShowDrawer(false);

  const {
    productsList,
    fetchingProductsList,
    addingPoItems,
    poDetails
  } = useSelector((state) => state.pos || {});

  const { vendor } = poDetails || {};
  const {
    createNewVendorItemLoading
  } = useSelector((state) => state.vendorItems || {});

  useEffect(() => {
    dispatch(GetProductsList({
      id: poId,
      filters
    }));
  }, []);

  const refreshProducts = () => {
    dispatch(GetProductsList({
      id: poId,
      filters
    }));
  }


  const addDetailsHandle = () => {
    dispatch(AddPoItems({
      products: mappedProducts?.map(({
        identifier_value,
        unit_cost,
        order_quantity,
        case_quantity,
        notes
      }) => ({
        identifier_value,
        unit_cost: Number(unit_cost),
        order_quantity: Number(order_quantity),
        case_quantity: Number(case_quantity),
        notes
      })),
      id: poId
    })).then(({ payload }) => {
      if (payload?.success) {
        // setAddProduct(true);
        setShowDrawer(false);
        refreshPage();
      }
    });
  }

  const gridReady = (params) => {
    gridApi = params.api;
    handleRowsSelection();
  };

  const handleDeleteProduct = (id) => {
    setMappedProducts(mappedProducts.filter((product) => product.id !== id));
  };

  const handleUpdateProduct = ({ index, key, value }) => {
    const productsClone = cloneDeep(mappedProducts);
    productsClone[index][key] = value;
    setMappedProducts(productsClone);
  };

  const onSelectionChange = (e) => {
    const data = [];
    gridApi.forEachNode((node) => {
      if (node.selected) {
        node.setSelected(true);
        data.push({
          ...node?.data,
          order_quantity: '',
          case_quantity: '',
          unit_cost: '',
          notes: '',
        });
      }
    });

    setMappedProducts(data);
  };

  const handleRowsSelection = () => {
    gridApi?.forEachNode((node) => {
      const index = findIndex(mappedProducts, { id: node.data.id });
      if (index !== -1) node.setSelected(true);
    });
  };

  const getBtnDisabledText = () => {
    const dataLength = mappedProducts?.length || 0;
    if (!dataLength) return 'Please select at least 1 product';

    let errorMsg = '';
    for (let i = 0; i < dataLength; i++) {
      const {
        name,
        order_quantity,
        case_quantity,
        avg_price,
        notes,
        unit_cost
      } = mappedProducts[i];

      if (!order_quantity) {
        errorMsg = `Enter Order Quantity for Vendor Item - ${name}`;
        break;
      }

      if (!unit_cost) {
        errorMsg = `Enter Unit Cost for Vendor Item - ${name}`;
        break;
      }

      if (order_quantity <= 0) {
        errorMsg = `Invalid Order Quantity for Vendor Item - ${name}`;
        break;
      }

      if (case_quantity && case_quantity <= 0) {
        errorMsg = `Invalid Case Quantity for Vendor Item - ${name}`;
        break;
      }

      if (unit_cost && unit_cost <= 0) {
        errorMsg = `Invalid Unit Cost for Vendor Item - ${name}`;
        break;
      }
    }

    return errorMsg;
  };

  const handleCreateVendorItem = (key, value) => {
    setCreateVendorItem((prev) => ({
      ...prev,
      [key]: value
    }))
  };

  const handleCreateVendorItemDisabled = () => {
    const { identifierValue, identifierType, vendorItemName, brand, moq, caseQuantity } = createVendorItem;

    if (!vendorItemName || !brand || !identifierType || !identifierValue) return true;
    if (getIdentifierValidationError(identifierType, identifierValue)) return true;
    if (moq) {
      if (isNaN(Number(moq))) return true;
      if (moq != null && isNaN(Number(moq)) || (moq != null && moq < 1)) return true;
    }
    if (caseQuantity) {
      if (isNaN(Number(caseQuantity))) return true;
      if (caseQuantity != null && isNaN(Number(caseQuantity)) || (caseQuantity != null && caseQuantity < 1)) return true;
    }
    return false;
  };

  const createNewVendorItem = () => {
    dispatch(CreateNewVendorItem({
      vendorName: vendor?.name,
      ...createVendorItem
    })).then(() => {
      setAddVendorItem(false);
      setSelectedOption(null);
      setCreateVendorItem({});
      refreshProducts();
    });
  }

  const handleSearchProduct = debounce((value) => {
    if (trim(value) || filters.search) {
      setFilters({ search: value });
      dispatch(GetProductsList({
        id: poId,
        filters: { search: trim(value) },
      }));
    }
  }, 800);

  const disabledText = getBtnDisabledText();

  const handleChange = (option) => {
    if (!option) {
      handleCreateVendorItem('identifierType', '');
      setSelectedOption(option);
      return;
    }
    const { value = '' } = option
    setSelectedOption(option);
    handleCreateVendorItem('identifierType', value);
  };

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null)

    if (value && ['available_stock', 'avg_price'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      dispatch(GetProductsList({
        id: poId,
        filters,
        sortBy: { key: colId, type: sort }
      }));
    }
  };

  const handleBackClick = () => {
    if (showAddDetails) setShowAddDetails(false);
    else closeDrawer();
  };

  const options = [
    { value: 'upc', label: 'UPC' },
    { value: 'ean', label: 'EAN' },
    { value: 'ISBN', label: 'ISBN' },
    { value: 'GTIN', label: 'GTIN' }
  ];

  return (
    <Drawer
      show={showDrawer}
      onHide={closeDrawer}
      size="810px"
      crossIcon={false}
      className="add-product-upload-wrapper"
    >
      <DrawerWrapperUI>
        <header>
          <div className='left-content'>
            <img onClick={handleBackClick} src={LeftArrow} alt={LeftArrow} title={LeftArrow} />
            <h6>Add Vendor Items</h6>
          </div>
          {!showAddDetails ?
            <div className='right-content'>
              <SearchInput
                placeholder="Search by Identifier / Title"
                width="264px"
                onChange={({ target }) => handleSearchProduct(target.value)}
              />
              <Button
                onClick={() => setAddVendorItem(true)}
                text="Create Vendor Item"
              />
              <Button
                onClick={() => setShowAddDetails(true)}
                text="Add To PO"
                disabled={!mappedProducts?.length}
              />
            </div>
            :
            <Button
              onClick={addDetailsHandle}
              text="Save"
              disabled={disabledText}
            />
          }
        </header>
        {(showAddDetails && mappedProducts.length === 0) && <p className='no-data-found'>No Data Found</p>}
        {showAddDetails ?
          <Spin tip='Loading...' spinning={addingPoItems}>
            <div className="card-items-wrapper">
              {mappedProducts?.map(({
                vendor_item_name,
                id,
                identifier_type,
                identifier_value,
                order_quantity,
                unit_cost,
                case_quantity,
                notes,
                image_url,
                description
              }, index) => (
                <div key={index} className="card-items">
                  <h6>Vendor Item Details</h6>
                  <div className="title-wrapper">
                    <div className="name-img">
                      {/* <img src={image_url || ProductImg} alt={vendor_item_name} /> */}
                      <p>{vendor_item_name}</p>
                    </div>
                    <div className="upc-items">
                      <p>Identifier/value</p>
                      <a href="#">{identifier_type} / {identifier_value}</a>
                    </div>
                    <span className="icon">
                      <AiOutlineDelete onClick={() => handleDeleteProduct(id)} />
                    </span>
                  </div>
                  <div className="inputs-wrapper">
                    <Input
                      type="number"
                      placeholder={(index + 1) * 10}
                      important
                      label="Order Qty"
                      value={order_quantity || ''}
                      onChange={({ target }) => handleUpdateProduct({ index, key: 'order_quantity', value: target?.value })}
                    />
                    <Input
                      type="number"
                      placeholder={(index + 1) * 10}
                      optional
                      label="Case Qty"
                      value={case_quantity || ''}
                      onChange={({ target }) => handleUpdateProduct({ index, key: 'case_quantity', value: target?.value })}
                    />
                    <Input
                      type="number"
                      placeholder={`${(index + 1) * 10}`}
                      important
                      label="Unit Cost"
                      value={unit_cost || ''}
                      onChange={({ target }) => handleUpdateProduct({ index, key: 'unit_cost', value: target?.value })}
                    />
                    <Input
                      placeholder={'Type Notes Here'}
                      label="Notes"
                      value={notes || ''}
                      onChange={({ target }) => handleUpdateProduct({ index, key: 'notes', value: target?.value })}
                    />
                  </div>
                </div>
              ))}
            </div>
          </Spin>
          :
          <Spin tip='Loading...' spinning={fetchingProductsList}>
            <AgGrid
              user_referrals={productsList}
              defaultColDef={defaultColDefNew}
              columnDefinitions={columnDefs}
              gridReady={gridReady}
              onSelectionChanged={onSelectionChange}
              onSortChange={onSortChange}
              rowHeight={64}
              headerHeight={36}
              height="105px"
              masterDetail={false}
              detailRowAutoHeight={false}
              className="sku-table"
              rowSelection='multiple'
            />
          </Spin>}
        <Modal
          open={AddVendorItem}
          onClose={() => setAddVendorItem(false)}
          onHide={() => setAddVendorItem(false)}
          removeIcon
        >
          <Spin tip='Creating..' spinning={createNewVendorItemLoading} >
            <DrawerWrapperUI className='modal-ui-parent-wrapper'>
              <Box className="modal-box-container" display="flex" flexDirection="column" gap={4}>
                <h6>Create Vendor Item</h6>
                <Box marginTop={4.5} display="grid" alignItems="end" gridTemplateColumns="1fr 1fr" gap={2} rowGap={3}>
                  <ReactSelect
                    value={selectedOption}
                    onChange={handleChange}
                    options={options}
                    important
                    label="Identifier"
                    placeholder="Select"
                    isClearable
                  />
                  <Input
                    placeholder="Enter"
                    label="Identifier Value"
                    important
                    type='number'
                    min={1}
                    value={createVendorItem?.identifierValue}
                    onChange={(e) => {
                      handleCreateVendorItem('identifierValue', e.target.value)
                    }}
                  />
                  <Input
                    placeholder="Enter"
                    label="Item Name"
                    important
                    value={createVendorItem?.vendorItemName}
                    onChange={(e) => {
                      handleCreateVendorItem('vendorItemName', e.target.value)
                    }}
                  />
                  <Input
                    placeholder="Enter"
                    label="Brand"
                    important
                    value={createVendorItem?.brand}
                    onChange={(e) => {
                      handleCreateVendorItem('brand', e.target.value)
                    }}
                  />
                  <Input
                    placeholder="Enter"
                    label="MOQ (Minimum Order Quantity)"
                    value={createVendorItem?.moq}
                    type='number'
                    onChange={(e) => {
                      handleCreateVendorItem('moq', e.target.value)
                    }}
                  />
                  <Input
                    placeholder="Enter"
                    label="Case Qty"
                    value={createVendorItem?.caseQuantity}
                    type='number'
                    onChange={(e) => {
                      handleCreateVendorItem('caseQuantity', e.target.value)
                    }}
                  />
                </Box>
              </Box>
              <Box display="flex" justifyContent="end" alignItems="end" marginTop={4} flexDirection="row" gap={2}>
                <Button
                  onClick={() => setAddVendorItem(false)}
                  text="Cancel"
                  className="outlined m-0"
                />
                <Button
                  onClick={() => {
                    createNewVendorItem()
                  }
                  }
                  text={createNewVendorItemLoading ? 'Saving..' : 'Save'}
                  className="primary m-0"
                  disabled={createNewVendorItemLoading || handleCreateVendorItemDisabled()}
                />
              </Box>
            </DrawerWrapperUI>
          </Spin>
        </Modal>
      </DrawerWrapperUI>
    </Drawer>
  )
}

export default AddProductByUpload;
